<template>
  <div>
    
    <div class="rowflex">
      <div class="columnflex flexcenter">
        <div class="paddingLeft25px">
          <p class="maintitle">{{ resume.title }}</p>
          <p class="discription">{{ resume.description }}</p>
        </div>
      </div>
      <div class="columnflex">
        <div class="text-center">
          <img :src="resume.photo" class="face" :alt="resume.title" />
        </div>
      </div>
    </div>

    <div class="rowflex">
      <div class="columnflex">
        <div class="fill experience">
          <Experience :items="resume.experience" />
          <Education :items="resume.education" />
          <div class="row workitem spanWorkItem">
            <div class="col-xs-12 vcenter"></div>
          </div>
        </div>
      </div>
      <div class="columnflex">
        <div class="fill secondBlock">
          <About :items="resume.about" />
          <Contact :items="resume.contact" />
          <Skill :items="resume.skill" />
          <div class=" text-center paddingTop50px paddingBottom20px">
                    <embed width="100px" type="image/svg+xml" src="images/logo.svg" />
          </div> 
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Contact from "./components/Contact.vue";
import About from "./components/About.vue";
import Education from "./components/Education";
import Experience from "./components/Experience";
import Skill from "./components/Skill";
import axios from 'axios'

export default {
  name: "app",
  data() {
    return {
      resume: {}
    };
  },
  async created () {
    this.resume = await this.fetchResume()
  },
  components: {
    Contact,
    About,
    Education,
    Experience,
    Skill
  },
  methods: {
    fetchResume () {
      return axios.get('/resume.json').then(response => {
          return response.data;
      })
    }
  }
};
</script>
